import React, { useState } from "react";
import AdminContactHero from "./AdminContactHero";
import AdminContactManager from "./AdminContactManager";


const Contact = () => {


  const TABS = {
    hero: "ContactHero",
    contact: "ContactContent",

  };

  // Default to the Hero tab
  const [activeTab, setActiveTab] = useState(TABS.hero);

  // Function to switch tabs
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="p-4 space-y-8">
      {/* Top Buttons */}
      <div className="flex flex-wrap gap-4 mb-6">
        <button
          onClick={() => handleTabChange(TABS.hero)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.hero
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          Contact Hero
        </button>
        <button
          onClick={() => handleTabChange(TABS.contact)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.contact
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          Contact Content
        </button>
      </div>

      {/* Render selected component */}
      <div className="bg-gray-50 p-4 rounded shadow">
        {activeTab === TABS.hero && <AdminContactHero />}
       { activeTab === TABS.contact && <AdminContactManager />}
      </div>
    </div>
  );
};

export default Contact;